<template>
  <div class="">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="125px"
      class="demo-ruleForm"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$t('ltladdress.form.shippingReceivingPlace')">
            <el-select v-model="value1" :placeholder="$t('ltladdress.form.pleaseSelectShippingReceivingPlace')" style="width: 100%">
              <!-- <el-option :label="$t('ltladdress.form.originLocation')" :value="1"></el-option>
              <el-option :label="$t('ltladdress.form.destinationLocation')" :value="2"></el-option> -->
              <el-option label="Origin Location" :value="1"></el-option>
              <el-option label="Destination Location" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('ltladdress.form.addressType')" prop="addressFunction">
            <el-select
              v-model="ruleForm.addressFunction"
              :placeholder="$t('ltladdress.form.pleaseSelectAddressType')"
              style="width: 100%"
            >
              <el-option :label="$t('ltladdress.form.shippingAddress')" value="0"></el-option>
              <el-option :label="$t('ltladdress.form.receivingAddress')" value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('ltladdress.form.contactPerson')" prop="userName">
            <el-input v-model="ruleForm.userName" :placeholder="$t('ltladdress.form.pleaseEnterContactPerson')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('ltladdress.form.contactEmail')" prop="email">
            <el-input v-model="ruleForm.email" :placeholder="$t('ltladdress.form.pleaseEnterContactEmail')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('ltladdress.form.contactPhone')" prop="phone">
            <el-input
              v-model="ruleForm.phone"
              :placeholder="$t('ltladdress.form.pleaseEnterContactPhone')"
              class="input-with-select"
            >
              <el-select v-model="ruleForm.phoneCode" slot="prepend" :placeholder="$t('ltladdress.form.pleaseSelectPhoneCode')">
                <el-option label="United States" value="US"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('ltladdress.form.addressName')" prop="addressName">
            <el-input v-model="ruleForm.addressName" :placeholder="$t('ltladdress.form.pleaseEnterAddressName')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('ltladdress.form.address1')" prop="address1">
            <el-input v-model="ruleForm.address1" :placeholder="$t('ltladdress.form.pleaseEnterAddress1')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('ltladdress.form.address2')" prop="address2">
            <el-input v-model="ruleForm.address2" :placeholder="$t('ltladdress.form.pleaseEnterAddress2')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('ltladdress.form.zipCode')" prop="zipCode">
            <el-input
              v-model="ruleForm.zipCode"
              :placeholder="$t('ltladdress.form.pleaseEnterZipCode')"
              @blur="changeZipCode"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('ltladdress.form.city')" prop="city">
            <el-input v-model="ruleForm.city" :placeholder="$t('ltladdress.form.pleaseEnterCity')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('ltladdress.form.stateProvince')" prop="province">
            <el-select v-model="ruleForm.province" :placeholder="$t('ltladdress.form.pleaseSelectStateProvince')" style="width: 100%">
              <el-option
                v-for="(item, index) in proList"
                :key="index"
                :label="`${item.province}-${item.province_code}`"
                :value="item.province_code"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="$t('ltladdress.form.country')" prop="country">
            <el-input v-model="ruleForm.country" :placeholder="$t('ltladdress.form.pleaseSelectCountry')" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item prop="isDefault">
        <el-checkbox
          v-model="ruleForm.isDefault"
          :checked="ruleForm.isDefault == 0 ? true : false"
          true-label="0"
          false-label="1"
          name="isDefault"
          >{{ $t('ltladdress.form.setAsDefaultAddress') }}</el-checkbox>
      </el-form-item>
      <el-form-item style="text-align: right">
        <el-button size="small" type="primary" @click="submitForm('ruleForm')">{{ $t('ltladdress.form.submit') }}</el-button>
        <el-button size="small" @click="resetForm('ruleForm')">{{ $t('ltladdress.form.reset') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { addressAdd, addressUpdate, provinceList, zipCode } from "@/api/ltl/address";
import { validatenull } from "@/common/common.js";
export default {
  props: {
    record: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      value1: "", // 没有传参的占位数据
      ruleForm: {
        country: "US",
        phoneCode: "US",
      },
      rules: {
        addressFunction: [{ required: true, message: this.$t('ltladdress.form.pleaseSelectAddressType'), trigger: "change" }],
        userName: [{ required: true, message: this.$t('ltladdress.form.pleaseEnterContactPerson'), trigger: "blur" }],
        email: [{ required: true, message: this.$t('ltladdress.form.pleaseEnterContactEmail'), trigger: "blur" }],
        phoneCode: [{ required: true, message: this.$t('ltladdress.form.pleaseSelectPhoneCode'), trigger: "change" }],
        phone: [{ required: true, message: this.$t('ltladdress.form.pleaseEnterContactPhone'), trigger: "blur" }],
        addressName: [{ required: true, message: this.$t('ltladdress.form.pleaseEnterAddressName'), trigger: "blur" }],
        address1: [{ required: true, message: this.$t('ltladdress.form.pleaseEnterAddress1'), trigger: "blur" }],
        zipCode: [{ required: true, message: this.$t('ltladdress.form.pleaseEnterZipCode'), trigger: "blur" }],
        city: [{ required: true, message: this.$t('ltladdress.form.pleaseEnterCity'), trigger: "change" }],
        province: [{ required: true, message: this.$t('ltladdress.form.pleaseSelectStateProvince'), trigger: "change" }],
      },
      proList: [], // 国家-城市
      id: "",
    };
  },
  mounted() {
    this.getProvinceList();
    if (!validatenull(this.record)) {
      this.id = this.record.id;
      this.ruleForm = {
        ...this.record,
      };
    }
  },
  methods: {
    // 获取省
    getProvinceList() {
      provinceList().then((res) => {
        this.proList = res.data;
      });
    },

    // 通过邮编获取州城市
    changeZipCode(num) {
      zipCode({
        zipCode: this.ruleForm.zipCode,
      }).then((res) => {
        if (res.code == 1) {
          this.ruleForm = {
            ...this.ruleForm,
            province: res.data.province,
            city: res.data.city,
          };
        } else {
          this.ruleForm = {
            ...this.ruleForm,
            province: '',
            city:'',
          };
          // this.ruleForm.province = "";
          // this.ruleForm.city = "";
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let form = this.ruleForm;
          if (this.id) {
            addressUpdate({
              address_id: this.id,
              u_id: JSON.parse(window.localStorage.getItem("userInfo1")).user_id,
              ...form,
              isDefault: form.isDefault ? form.isDefault : "1",
            })
              .then((res) => {
                if (res.code == 1) {
                  this.$message.success(this.$t('ltladdress.form.updateSuccess'));
                  this.$emit("ok");
                } else {
                  this.$message.error(this.$t('ltladdress.form.updateFailed'));
                }
              })
              .catch((err) => {
                this.$message.error(err.msg);
              });
          } else {
            addressAdd({
              u_id: JSON.parse(window.localStorage.getItem("userInfo1")).user_id,
              ...form,
              isDefault: form.isDefault ? form.isDefault : "1",
            })
              .then((res) => {
                if (res.code == 1) {
                  this.$message.success(this.$t('ltladdress.form.submitSuccess'));
                  this.$emit("ok");
                } else {
                  this.$message.error(this.$t('ltladdress.form.submitFailed'));
                }
              })
              .catch((err) => {
                this.$message.error(err.msg);
              });
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm = {
        country: "US",
        phoneCode: "US",
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.code {
  font-size: 14px;
  cursor: pointer;
  color: #409eff;
  margin-left: 10px;
  flex: 1;
  text-align: right;
  width: 100px;
  float: right;
}
.input-with-select /deep/.el-input-group__prepend {
  width: 90px;
  background-color: #fff;
}
</style>